export default __webpack_public_path__ + "static/media/watertoken256.d860f17d.png";